export default __webpack_public_path__ + "static/media/icon-chatroom.39b2b7ab.png";